import { t } from 'i18next';
import { Box, Flex } from 'reflexbox';

import { Container, Heading3, PAGE_CONTENT_WIDTH, Spinner, tokens } from '@treams/treams-ui';

export default function SubgoalsContainer({
	children,
	loading,
}: {
	children: React.ReactNode;
	loading?: boolean;
}) {
	return (
		<Container py={`${tokens.gap.section}px`} wide={PAGE_CONTENT_WIDTH}>
			<Heading3 mb={`${tokens.gap.list}px`}>
				<Flex alignItems="center">
					<Box>{t('subgoals.list.title')}</Box>
					{loading && <Spinner ml={2} />}
				</Flex>
			</Heading3>
			{children}
		</Container>
	);
}
